import { useQuery } from '@tanstack/react-query';

import { getChatConversations } from '~/services/TripPlannerService';

import { tripPlannerQueryKeys } from './tripPlannerQueryKeys';

export function useGetChatOrigin(chatId: string) {
  return useQuery({
    queryKey: [...tripPlannerQueryKeys.chatConversations(), 'origin', chatId],
    queryFn: ({ signal }) => getChatConversations({ page: 1, pageSize: 1, chatId }, { signal }),
    select: (data) => data.result.trips[0]?.origin,
    enabled: Boolean(chatId),
  });
}
